import React, { useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// api
import { recoverPassword } from 'api/users';
// components
import { InputCustom } from 'components/input';
import Head from 'components/metatags_helmet/metatags';

const SendMailRecover = () => {
  const [feedback, setFeedback] = useState('');
  const [successSendEmail, setSuccessSendEmail] = useState(false);
  const [email, setEmail] = useState('');
  const { t } = useTranslation(['backoffice']);

  const onRecover = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setSuccessSendEmail(false);
    setFeedback('');

    if (email.length > 0) {
      const payload = { email };
      const { status } = await recoverPassword(payload);
      if (status === 200) {
        setSuccessSendEmail(true);
      } else if (status === 404) {
        setFeedback(t('wrongEmail'));
      } else {
        setFeedback(t('networkProblemEmail'));
      }
    } else {
      setFeedback(t('messageFailEmail'));
    }
  };

  return (
    <div className="container-fluid mainDiv container">
      <Head title={t('cambiarcontrasena')} noIndex={true} />
      <Row className="mainRow infoRow">
        <Col lg={12} className="mt-4">
          <div className="container mb-5">
            <h1 className="infoTitle">{t('resetpassword')}</h1>
            <hr />
          </div>
          <div className="form-styles">
            <div className="form-recover">
              <p className="mb-0 pb-1 inputTitle openSans">{`${t('correoelectronico')}*`}</p>
              <Form onSubmit={onRecover}>
                <InputCustom
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder={t('placeholderEmail')}
                />
                <span className="feedback">{feedback}</span>
                {successSendEmail && (
                  <Row className="alert-success">
                    <span>{t('messageSuccessEmail')}</span>
                  </Row>
                )}
                <Button
                  type="submit"
                  className="blue-btn px-4 py-1 openSans mt-3 send-btn"
                >
                  {t('enviar').toLocaleUpperCase()}
                </Button>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SendMailRecover;
